<template>
	<WizardInputFieldLayout :title="title">
		<template #input>
			<div class="icon-container flex-align-center">
				<ButtonsDropdownIcon
					:buttonDropdown="{ icon_color: iconColor, icon_name: iconName, tooltip_text: tooltipText, main_screen_text: mainScreenText }"
				/>
			</div>
		</template>
	</WizardInputFieldLayout>
</template>

<script>
import ButtonsDropdownIcon from '@/components/ButtonsDropdown/ButtonsDropdownIcon.vue';
import WizardInputFieldLayout from '@/components/common/WizardInputFieldLayout.vue';

export default {
	name: 'ButtonDropdownIconPreview',
	components: { WizardInputFieldLayout, ButtonsDropdownIcon },
	props: {
		title: { type: String, required: true },
		iconColor: { type: String },
		iconName: { type: String },
		tooltipText: { type: String },
		mainScreenText: { type: String },
	},
};
</script>

<style lang="scss" scoped>
.icon-container {
	height: 36px;
}
</style>
